/**
 * Workflow 설정 라우트 (/admin/workflow-settings)
 * @description 새 전용 UI로 리다이렉트
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/workflow-settings')({
  beforeLoad: () => {
    throw redirect({ to: '/workflow-settings' });
  },
  component: () => null,
});
